import axios from "axios";

const axiosInstanceApi = axios.create({
  baseURL: "/api/",
});

axiosInstanceApi.interceptors.response.use(
  (res) => res,
  (e) => {
    axiosInstanceApi.$callback.err(e.message);
    const statusCode = e.response ? e.response.status : null;
    const defaultMessage = "Возникла ошибка при выполнении запроса к серверу";
    if (statusCode === 500) {
      axiosInstanceApi.$notifier.error(
        'Ошибка обработки запроса на сервере.'
      );
      return Promise.reject(e);
    }
    if (statusCode === 401) {
      axiosInstanceApi.$callback.errAuth();
      axiosInstanceApi.$notifier.error(
        'Ошибка авторизации на сервере.'
      );
      location.replace("/#/login");
      return Promise.reject(e);
    }
    if (statusCode === 404) {
      axiosInstanceApi.$notifier.error(
        'Отсутствует доступ к серверу. Попробуйте позже или обратитесь к системному администратору.'
      );
      return Promise.reject(e);
    }
    axiosInstanceApi.$notifier.error(
      e?.response?.data?.error?.message || defaultMessage
    );
    return Promise.reject(e);
  }
);

export default axiosInstanceApi;